import React from 'react'
import { inject, observer } from 'mobx-react'
import { formatCompactNumber } from '../../../utils'

const MetricsSection = ({
  safeDensity,
  safeSize,
  areaUnit,
  rightSidebarStore,
  selectionStore
}) => {
  const changeUnit = () => {
    if (rightSidebarStore) {
      rightSidebarStore.toggleAreaUnit()
    }
  }

  const currentUnit = rightSidebarStore ? rightSidebarStore.areaUnit : (areaUnit || 'km²')

  const getRegionAnalysisAreaKm = () => {
    const item = selectionStore && selectionStore.item
    if (item && item.analysis && item.analysis.valid && Number.isFinite(item.analysis.area)) {
      return item.analysis.area
    }
    if (rightSidebarStore && rightSidebarStore.areaKm != null) {
      return rightSidebarStore.areaKm
    }
    return null
  }

  const areaKm = getRegionAnalysisAreaKm()

  const formatMetricValue = (num) => {
    if (num == null || isNaN(num)) return '0'
    if (num < 1) {
      return formatCompactNumber(num, { maximumFractionDigits: 2, minimumFractionDigits: 1 })
    }
    return formatCompactNumber(num, { maximumFractionDigits: 0, minimumFractionDigits: 0 })
  }

  const getAreaValue = () => {
    if (areaKm == null) {
      if (safeSize) {
        const sizeValue = parseFloat(safeSize.replace(/[^\d.]/g, ''))
        return Number.isFinite(sizeValue) ? sizeValue : 0
      }
      return 0
    }

    return currentUnit === 'mi²' ? areaKm * 0.386102 : areaKm
  }

  const displayValue = getAreaValue()
  const showUnitButton = areaKm != null

  return (
    <div className='people-data-sidebar__section people-data-sidebar__section--metrics'>
      <div className='people-data-sidebar__metrics-grid'>
        <div className='people-data-sidebar__metric-card people-data-sidebar__metric-card--density'>
          <div className='people-data-sidebar__metric-label'>
            Density
          </div>
          <div className='people-data-sidebar__metric-value'>
            {(() => {
              const densityVal = Number(safeDensity)
              if (isNaN(densityVal)) return '0'
              return formatCompactNumber(densityVal, { maximumFractionDigits: 0, minimumFractionDigits: 0 })
            })()}
          </div>
        </div>
        <div className='people-data-sidebar__metric-card people-data-sidebar__metric-card--size'>
          <div className='people-data-sidebar__metric-label'>
            Size
          </div>
          <div className='people-data-sidebar__metric-value'>
            <div className='people-data-sidebar__size-value-container'>
              <div className='people-data-sidebar__size-number'>{formatMetricValue(displayValue)}</div>
              {showUnitButton && (
                <button
                  className='people-data-sidebar__size-unit-button'
                  onClick={changeUnit}
                  type='button'
                >
                  {currentUnit}
                </button>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default inject('selectionStore')(observer(MetricsSection))
